export default __webpack_public_path__ + "static/media/sel_friends.4925d8bf.svg";